import { formatSecondsToDurationLabel } from "@memorang/helpers/common";
import { StyleSheet } from "react-native";
import { Chip, Icon, IconButton } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type ActionRowProps = {
	durationSeconds: number;
	isPlaying: boolean;
	isBookmarked: boolean;
	isInQueue: boolean;
	onPlayPress: () => void;
	onToggleQueue: () => void;
	onToggleBookmark: () => void;
	onShare: () => void;
};

const ActionRow = ({
	durationSeconds,
	isPlaying,
	isBookmarked,
	isInQueue,
	onPlayPress,
	onToggleQueue,
	onToggleBookmark,
	onShare,
}: ActionRowProps) => {
	const theme = useAppTheme();

	const ACTIONS = [
		{
			icon: isInQueue ? "playlist-check" : "playlist-plus",
			onPress: onToggleQueue,
			label: isInQueue ? "Remove from queue" : "Add to queue",
		},
		{
			icon: isBookmarked ? "bookmark" : "bookmark-outline",
			onPress: onToggleBookmark,
			label: isBookmarked ? "Remove bookmark" : "Bookmark",
		},
		{
			icon: "share-variant-outline",
			onPress: onShare,
			label: "Share",
		},
	];

	return (
		<Box flexDirection="row" alignItems="center" gap={8}>
			<Chip
				icon={() => (
					<Icon
						source={isPlaying ? "pause" : "play"}
						size={18}
						color={theme.colors.onSurface}
					/>
				)}
				mode="outlined"
				onPress={onPlayPress}
				accessibilityLabel={
					isPlaying
						? "Pause episode"
						: `Play episode, ${formatSecondsToDurationLabel(durationSeconds)}`
				}
				style={[
					styles.chip,
					{
						borderColor: theme.colors.outlineVariant,
					},
				]}
				textStyle={{ color: theme.colors.onSurface }}
			>
				{formatSecondsToDurationLabel(durationSeconds)}
			</Chip>
			<Box flexDirection="row" alignItems="center">
				{ACTIONS.map(({ icon, onPress, label }) => (
					<IconButton
						key={label}
						icon={icon}
						size={24}
						onPress={onPress}
						iconColor={theme.colors.onSurfaceVariant}
						style={styles.iconButton}
						accessibilityLabel={label}
					/>
				))}
			</Box>
		</Box>
	);
};

const styles = StyleSheet.create({
	chip: {
		borderRadius: 8,
	},
	iconButton: {
		width: 48,
		height: 48,
	},
});

export default ActionRow;
